import React from 'react'
import Page from '../Page';

const SCD = ({ testResult }) => {
    return (
        <>
            <Page testResult={testResult} title="معرفی الگوی رفتاری SCD">
                <p className="text-gray-800 leading-7">
                    الگوی رفتاری  SCD ترکیبی از ثبات، قانون‌گرایی و تسلط
                    الگوی رفتاری  SCD ترکیبی از سه بُعد اصلی رفتاری است:
                </p>
                <ul className="list-disc list-inside space-y-2">
                    <li>
                        S ثبات‌گرایی: فردی آرام، همراه، صبور و وفادار.
                    </li>
                    <li>
                        C وظیفه‌گرایی و قانون‌گرایی: تحلیلی، منظم، دقیق و علاقه‌مند به ساختار.
                    </li>
                    <li>
                        D تسلط‌گرایی: قاطع، نتیجه‌گرا و متمرکز بر دست‌یابی به اهداف.
                    </li>
                </ul>
            </Page>

            <Page testResult={testResult} title="معرفی الگوی رفتاری SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p className="text-gray-800 leading-7">
                        افراد دارای این الگو، جزو دقیق‌ترین، ساختارمندترین و در عین حال پیگیرترین افراد در محیط‌های کاری هستند. آن‌ها هم اهل تحلیل‌اند، هم در انجام امور سماجت دارند و هم برای رسیدن به نتیجه، حاضرند خودشان دست به کار شوند. اما با رویکردی درون‌گرا، کمتر احساساتشان را بروز می‌دهند و ترجیح می‌دهند در چارچوب‌ها و با کنترل کامل بر موقعیت، امور را پیش ببرند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="این افراد معمولاً چطور دیده می‌شوند؟">
                <div className="text-gray-800 leading-7 space-y-3">
                    <ul className="list-disc list-inside space-y-2">
                        <li>
                            فردی باهوش، آرام، جدی، قابل اعتماد و کمی سخت‌گیر.
                        </li>
                        <li>کسی که در جلسات بیشتر شنونده است و ناگهان با تحلیلی عمیق، همه را شگفت‌زده می‌کند.</li>
                        <li>مدیری که حتی اگر دوست‌داشتنی باشد، نمی‌گذارد استانداردها شکسته شوند.</li>
                        <li>هم‌تیمی‌ای که آرام است، اما اگر کاری بی‌دقت انجام شود، نمی‌گذارد به راحتی از کنارش بگذری.</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="نقاط قوت SCDها">
                <div className="text-gray-800 leading-7 space-y-3">
                    <ul className="list-disc list-inside space-y-2">
                        <li>توان بالای تحلیل اطلاعات پیچیده</li>
                        <li>نگاه کل‌نگر در کنار دقت به جزئیات</li>
                        <li>تعهد کاری و وفاداری به سازمان</li>
                        <li>قدرت تصمیم‌گیری دقیق، با در نظر گرفتن همه ابعاد</li>
                        <li>پیگیری سرسختانه تا رسیدن به نتیجه</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="نقاط قابل بهبود">
                <div className="text-gray-800 leading-7 space-y-3">
                    <ul className="list-disc list-inside space-y-2">
                        <li>گاهی بیش‌ازحد کمال‌گرا می‌شوند و تصمیم‌گیری را به تأخیر می‌اندازند.</li>
                        <li>در روابط بین‌فردی ممکن است خونسرد، خشک یا حتی بی‌احساس به‌نظر برسند.</li>
                        <li>انتقاد از دیگران را راحت‌تر از بیان احساسات مثبت انجام می‌دهند.</li>
                        <li>تمایل زیادی به کنترل دارند و واگذاری کار به دیگران برایشان دشوار است.</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="یک مثال کاربردی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>فرض کنید در یک پروژه شرکتی، مدیر پروژه فردی با الگوی  SCD است. او در ابتدای پروژه سند دقیق نیازمندی‌ها، گانت‌چارت، چارچوب‌ها و ساختار تصمیم‌گیری را طراحی می‌کند. اعضای تیم ممکن است از روند آهسته اولیه خسته شوند، اما همین فرد در مرحله اجرا به‌شدت پیگیر، دقیق و نتیجه‌گراست. اگر عضوی از تیم کار را با بی‌دقتی یا بدون تحلیل انجام دهد،  SCD  به‌شدت واکنش نشان می‌دهد، اما بدون هیاهو ، فقط با دلایل منطقی و مستندات.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ابعاد و توصیف ویژگی‌های رفتاری در الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        الگوی  SCD، همان‌طور که از ترکیب سه بعد شخصیتی S  ثبات‌گرا ،  C  وظیفه‌گرا و D  تسلط‌گرا پیداست، شخصیت‌هایی منظم، وفادار، نتیجه‌گرا و به‌شدت تحلیل‌گر خلق می‌کند. در ادامه هر بُعد را با شاخصه‌های اصلی‌اش بررسی می‌کنیم:
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title=" 1. بُعد S ثبات‌گرایی در فرد SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <ul className="list-disc list-inside space-y-2">
                        <li>آرام، صبور و قابل اعتماد</li>
                        <li>اهل وفاداری به تیم، خانواده یا سازمان</li>
                        <li>علاقه‌مند به حفظ محیط باثبات و بدون تنش</li>
                        <li>اهل خدمت و همراهی با دیگران</li>
                        <li>پذیرای مسئولیت‌های بلندمدت و با ثبات</li>
                    </ul>
                    <p>
                        این ویژگی باعث می‌شود در سازمان، فردی متعهد، وفادار و اهل مشارکت دیده شوند که اهل تنش و درگیری نیستند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="2. بُعد C وظیفه‌گرایی و قانون‌گرایی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <ul className="list-disc list-inside space-y-2">
                        <li>دقیق، منظم، تحلیل‌گر</li>
                        <li>حساس به استانداردها و قوانین</li>
                        <li>تمایل به رعایت چارچوب‌ها</li>
                        <li>کمال‌گرا و سخت‌گیر روی کیفیت کار</li>
                        <li>علاقه‌مند به بررسی اطلاعات کامل قبل از تصمیم</li>
                    </ul>
                    <p>
                        همین ویژگی باعث می‌شود کارهای باکیفیت و دقیق تحویل دهند، اما ممکن است در مواقعی، روند کار را کند یا وسواس‌گونه کنند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="3. بُعد D تسلط‌گرایی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <ul className="list-disc list-inside space-y-2">
                        <li>نتیجه‌محور، عمل‌گرا و جدی</li>
                        <li>روحیه رقابتی بالا و علاقه‌مند به برنده شدن</li>
                        <li>سریع در عمل اما پس از تحلیل دقیق</li>
                        <li>تمایل به کنترل موقعیت و افراد</li>
                        <li>انگیزه بالا برای موفقیت‌های ملموس و اثربخش</li>
                    </ul>
                    <p>
                        این ویژگی آن‌ها را از S  یا C های کلاسیک جدا می‌کند؛ چون فقط به تحلیل یا ثبات قانع نیستند ، آن‌ها می‌خواهند با قدرت، کار را پیش ببرند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ترکیب این سه بُعد در SCD چه ویژگی‌هایی می‌سازد؟">
                <div className="text-gray-800 leading-7 space-y-3">
                    <ul className="list-disc list-inside space-y-2">
                        <li>پیگیری تا رسیدن به نتیجه برخاسته از D</li>
                        <li>وفاداری و همراهی با تیم برخاسته از S</li>
                        <li>دقت در تحلیل و برنامه‌ریزی برخاسته از C</li>
                    </ul>
                    <p>
                        اما ترکیب این سه بُعد می‌تواند فشار روانی درونی زیادی هم ایجاد کند، چرا که:
                    </p>
                    <ul className="list-decimal list-inside space-y-2">
                        <li>فرد باید هم آرام باشد S، هم نتیجه‌گرا D، هم دقیق و کمال‌گرا C</li>
                        <li>در نتیجه، ممکن است خودش را زیاد تحت فشار بگذارد و دچار استرس مزمن شود</li>
                        <li>چون هم به موفقیت فردی علاقه‌مند است، هم به وفاداری به گروه، تصمیم‌گیری برایش دشوار می‌شود</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="یک مثال از محیط کاری">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        تصور کنید خانم مهندس نظری یک  SCD است. او پروژه طراحی سازه‌ای را بر عهده دارد. کار را با تحلیل و جمع‌آوری اطلاعات آغاز می‌کند C .  تا می‌تواند از تیمش حمایت می‌کند و بی‌سروصدا کار را جلو می‌برد S . اما در جلسات کلیدی، محکم و نتیجه‌گرا ظاهر می‌شود، چون فشار نتیجه گرفتن را حس می‌کند D .
                    </p>
                    <p>
                        او با اینکه آرام و ساکت به نظر می‌رسد، اما درونی‌ترین انگیزه‌اش بردن پروژه به بالاترین سطح کیفیت و اثربخشی است.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="تشریح کامل الگوی رفتاری SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        فرد دارای الگوی رفتاری  SCD را می‌توان این‌گونه توصیف کرد:
                    </p>
                    <p>
                        فردی آرام و وفادار S  ، با  حساسیت بالا به قوانین و چارچوب‌ها C  و در عین حال هدف‌مند و نتیجه‌گرا D .
                    </p>
                    <p>
                        او در ظاهر ممکن است فردی خونسرد و ساکت به نظر برسد، اما در درونش موتور پویایی از تحلیل، ارزیابی، انگیزه برای موفقیت و وفاداری به تیم و ساختار در حال کار است.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ذهن یک SCD چطور کار می‌کند؟">
                <div className="text-gray-800 leading-7 space-y-3">
                    <ul className="list-disc list-inside space-y-2">
                        <li>در برابر یک مسئله یا چالش، ابتدا آن را به‌صورت منطقی تجزیه و تحلیل می‌کند C .</li>
                        <li>سپس بررسی می‌کند که چه راهی کمترین تنش و بیشترین هماهنگی را ایجاد می‌کند S .</li>
                        <li>در نهایت، روشی را انتخاب می‌کند که بیشترین شانس را برای نتیجه‌گیری دارد D ؛ حتی اگر نیاز باشد خودش وارد عمل شود و هدایت امور را بر عهده بگیرد.</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="در محیط کار">
                <div className="overflow-x-auto">
                    <table className="w-full text-right border border-gray-300 border-collapse">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="border border-gray-300 p-3 font-semibold">ویژگی</th>
                                <th className="border border-gray-300 p-3 font-semibold">توضیح</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border border-gray-300 p-3">برنامه‌ریزی</td>
                                <td className="border border-gray-300 p-3">کارها را بدون هیاهو، با نقشه پیش می‌برد.</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">روابط کاری</td>
                                <td className="border border-gray-300 p-3">ترجیح می‌دهد در تیمی کوچک و قابل اعتماد فعالیت کند. زیاد اهل تعاملات هیجانی و سطحی نیست.</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">مسئولیت‌پذیری</td>
                                <td className="border border-gray-300 p-3">با سخت‌کوشی بالا، پروژه‌ها را تا انتها پیش می‌برد؛ حتی اگر زمان‌بر یا سخت باشد.</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">حساسیت</td>
                                <td className="border border-gray-300 p-3">اگر نظم یا قانون زیر پا گذاشته شود، برخورد جدی اما منطقی می‌کند.</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">مشارکت</td>
                                <td className="border border-gray-300 p-3">تمایل دارد دیگران هم دقیق، منظم و محترمانه کار کنند؛ با افراد بی‌نظم یا شلخته به‌سختی کنار می‌آید.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Page>

            <Page testResult={testResult} title="در موقعیت‌های استرس‌زا">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        فرد  SCD ترجیح می‌دهد در محیط‌هایی با تغییرات کنترل‌شده و قوانین مشخص باشد. تغییرات ناگهانی، فشارهای بی‌منطق یا رفتارهای هیجانی ممکن است او را مضطرب و حتی بسته کند. در شرایط بحرانی:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>ابتدا عقب‌نشینی می‌کند و تحلیل می‌نماید</li>
                        <li>اگر فشار زیاد شود، ممکن است سرد و بی‌احساس به‌نظر برسد یا ناگهان منفجر شود به‌ویژه در بُعد D</li>
                        <li>بهترین حالت برای او، داشتن زمان کافی برای تصمیم‌گیری منطقی و چارچوب‌دار است</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="نمونه واقعی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        فرض کنید فردی با الگوی  SCD مسئول کنترل کیفیت یک کارخانه دارویی است.
                    </p>
                    <p>
                        او با نهایت دقت همه فرایندها را بررسی می‌کند C، با کارکنان تولید ارتباط محترمانه و همراهانه دارد S  و وقتی ببیند محصول نهایی از استاندارد فاصله دارد، بدون ملاحظه، تصمیم به توقف خط تولید می‌گیرد D . این تصمیم ممکن است نارضایتی برخی را به همراه داشته باشد، اما از نظر او، نتیجه‌گرایی باید همراه با استاندارد و سلامت باشد.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهاد فیلم برای درک بهتر تیپ رفتاری SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        Bridge of Spies پل جاسوس‌ها
                    </p>
                    <p>
                        شخصیت اصلی فیلم، "جیمز داناوان"، وکیل آرام، تحلیل‌گر، قانون‌مدار و در عین حال مصمم و قاطع است. او علی‌رغم فشارها، با صبوری و دقت، مسیر دیپلماسی را طی می‌کند و در نهایت به نتیجه‌ای بزرگ می‌رسد. این شخصیت نمونه‌ای عالی از یک  SCD حرفه‌ای در شرایط پیچیده است.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="انگیزه‌ها">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        افراد دارای الگوی  SCD، برای انگیزه گرفتن به محرک‌های بیرونی پرهیاهو نیاز ندارند. آن‌ها در درون خود انگیزه‌ای پایدار، عمیق و آرام دارند که بیشتر از جنس احساس تعهد، اثربخشی واقعی، احترام درونی و تمایل به انجام درست کارهاست.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="مهم‌ترین منابع انگیزشی SCDها">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۱. احساس ارزشمندی از انجام درست وظایف C</h3>
                    <p>
                        این افراد وقتی می‌دانند کاری که انجام می‌دهند با دقت، نظم و کیفیت بالا پیش می‌رود، احساس رضایت عمیق پیدا می‌کنند.
                    </p>
                    <p>
                        فرایند برایشان به‌اندازه نتیجه اهمیت دارد.
                    </p>
                    <p>
                        مثال: اگر یک  SCD مشغول تهیه گزارش مالی باشد، برایش مهم است که هیچ خطایی نباشد، همه چیز منطبق بر قوانین باشد، و در نهایت گزارش مورد تأیید مدیر و هیأت‌مدیره قرار بگیرد.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="مهم‌ترین منابع انگیزشی SCDها">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۲. دریافت احترام و اعتماد از دیگران S</h3>
                    <p>
                        SCDها به‌شدت به محیط‌های صمیمی، باثبات و امن عاطفی علاقه دارند. وقتی احساس کنند همکاران یا خانواده به آن‌ها اعتماد دارند، یا از آن‌ها مشورت می‌خواهند، به‌شدت انگیزه می‌گیرند.
                    </p>
                    <p>
                        مثال: اگر از او به‌عنوان کسی که «همیشه در بحران‌ها کنار تیم می‌ماند» یاد شود، انگیزه‌اش چند برابر می‌شود.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="مهم‌ترین منابع انگیزشی SCDها">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۳. دستیابی به نتایج ملموس و قابل دفاع D</h3>
                    <p>
                        اگرچه این افراد پرهیاهو نیستند، اما به‌نوعی نتیجه‌محوری دارند که در صورت دیده‌نشدن، ممکن است سرخورده شوند.
                    </p>
                    <p>
                        آن‌ها به دنبال دستاوردهایی هستند که منطقی، دقیق و پایدار باشند. رسیدن به یک هدف کیفی بلندمدت می‌تواند انگیزه‌ای عمیق در آن‌ها ایجاد کند.
                    </p>
                    <p>
                        مثال: فرد  SCD ممکن است برای اجرای کامل و بدون نقص یک پروژه ERP  در یک سازمان، ماه‌ها با دقت و بدون غر زدن کار کند، ولی زمانی خوشحال می‌شود که پروژه نتیجه بدهد و در گزارش رسمی، از عملکرد او نام برده شود.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی انگیزشی برای مدیران یا اطرافیان فرد SCD">
                <div className="overflow-x-auto">
                    <table className="w-full text-right border border-gray-300 border-collapse">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="border border-gray-300 p-3 font-semibold">نکته</th>
                                <th className="border border-gray-300 p-3 font-semibold">چرا مؤثر است؟</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border border-gray-300 p-3">به او مسئولیت‌های مشخص با خروجی قابل ارزیابی بدهید</td>
                                <td className="border border-gray-300 p-3">چون عاشق وضوح و چارچوب است</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">احترام، اعتماد و ارتباط صادقانه برقرار کنید</td>
                                <td className="border border-gray-300 p-3">چون وفاداری‌اش به محیط، از اینجا تغذیه می‌شود</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">به دستاوردهای منطقی‌اش اشاره کنید</td>
                                <td className="border border-gray-300 p-3">چون می‌خواهد دیده شود، ولی دنبال خودنمایی نیست</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">برای تصمیم‌گیری به او زمان بدهید</td>
                                <td className="border border-gray-300 p-3">عجله، انگیزه‌اش را نابود می‌کند</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Page>

            <Page testResult={testResult} title="فیلم پیشنهادی برای درک انگیزه‌های SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        Sully  2016  –  با بازی تام هنکس
                    </p>
                    <p>
                        خلبانی آرام، باوجدان، مسئول و در عین حال مقتدر که بدون هیاهو و با برنامه، هواپیمایی را در شرایط بحران نجات می‌دهد.
                    </p>
                    <p>
                        ترکیب کامل ثبات و تسلط و تحلیل – یعنی   SCD در موقعیت واقعی.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="عادت‌های کاری افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        فرد  SCD در محیط کار به‌صورت پیوسته، دقیق و قابل اعتماد عمل می‌کند. او مانند موتور آرام و منظم یک تیم است که شاید زیاد دیده نشود، اما همیشه در حال حرکت است و کار را به جلو می‌برد.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="عادت‌های کاری افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۱. برنامه‌ریزی دقیق و واقع‌بینانه</h3>
                    <p>
                        افراد  SCD برای شروع هر کاری، ابتدا آن را برنامه‌ریزی، دسته‌بندی و زمان‌بندی می‌کنند.
                    </p>
                    <p>
                        آن‌ها نمی‌توانند پروژه‌ای را بدون چارچوب یا بدون اطلاعات کافی شروع کنند.
                    </p>
                    <p>
                        مثال: اگر وظیفه مدیریت یک ایونت را به او بدهید، تا زمان تهیه چک‌لیست کامل، بودجه‌بندی، هماهنگی تیم‌ها و لیست اقدامات، کاری را آغاز نمی‌کند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="عادت‌های کاری افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۲. تمایل به ساختار مشخص و وظایف روشن</h3>
                    <p>
                        SCDها با تعریف دقیق مسئولیت‌ها، وظایف و نقش‌ها راحت‌تر هستند. ابهام در نقش‌ها یا تصمیم‌گیری‌های لحظه‌ای باعث افت عملکردشان می‌شود.
                    </p>
                    <p>
                        مثال: ترجیح می‌دهد بداند که در جلسه امروز او مسئول گزارش مالی است، نه اینکه به‌صورت ناگهانی انتظار سخنرانی از او داشته باشند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="عادت‌های کاری افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۳. وفاداری به کار و تیم</h3>
                    <p>
                        آن‌ها نسبت به تیم، مدیر، یا سازمان احساس تعهد دارند.
                    </p>
                    <p>
                        در شرایط سخت ترک نمی‌کنند، بلکه آرام و متمرکز به انجام وظایف ادامه می‌دهند.
                    </p>
                    <p>
                        مثال: وقتی سایر همکاران پروژه‌ای را رها می‌کنند،  SCD  هنوز به دنبال حل مسئله و بستن کامل کار است.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="عادت‌های کاری افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۴. تمرکز بر کیفیت و دقت در جزئیات</h3>
                    <p>
                        حتی اگر مهلت محدود باشد، کیفیت کار برای فرد  SCD  از سرعت مهم‌تر است.
                    </p>
                    <p>
                        در برابر فشار «زودتر تحویل بده»، معمولاً مقاومت می‌کند تا از صحت و دقت کار مطمئن شود.
                    </p>
                    <p>
                        مثال: هنگام تهیه یک پاورپوینت، روی فونت‌ها، املای کلمات، رنگ‌ها و چینش اسلایدها دقتی وسواسی دارد.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="عادت‌های کاری افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۵. همکاری آرام اما مؤثر</h3>
                    <p>
                        در تیم، معمولا پرچم‌دار نیست، اما پایه‌گذار و ستون‌ تیم است.
                    </p>
                    <p>
                        اهل رفاقت‌های پر سروصدا نیست، ولی به‌شدت قابل اعتماد است.
                    </p>
                    <p>
                        مثال: اگر شما فردی با انرژی بالا مثلاً High I  یا D  باشید، او همراهی بی‌صدا و آرامی برایتان خواهد بود که همیشه کاری برای حل مسائل دارد، حتی اگر خودش را مطرح نکند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نقاطی که نیاز به تقویت دارد">
                <div className="overflow-x-auto">
                    <table className="w-full text-right border border-gray-300 border-collapse">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="border border-gray-300 p-3 font-semibold">چالش</th>
                                <th className="border border-gray-300 p-3 font-semibold">راهکار پیشنهادی</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border border-gray-300 p-3">تأخیر در تصمیم‌گیری</td>
                                <td className="border border-gray-300 p-3">استفاده از تکنیک‌های اولویت‌بندی</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">سخت‌گیری زیاد روی جزئیات</td>
                                <td className="border border-gray-300 p-3">تمرین «تکمیل به‌جای کمال» در کارها</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">مقاومت در برابر تغییر</td>
                                <td className="border border-gray-300 p-3">مواجهه با پروژه‌های جدید به صورت مرحله‌ای و امن</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">ترجیح کار فردی به گروهی</td>
                                <td className="border border-gray-300 p-3">تمرین بازخورد گرفتن، اعتماد به تیم و تفویض</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهاد صحنه نمایشی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        در یک تیم پنج‌نفره، فرد  SCD کسی است که بودجه پروژه را دقیق بسته، جدول زمان‌بندی را تنظیم کرده و چک‌لیست اقدامات را پر کرده. وقتی دیگران بر سر نام برند یا طراحی لوگو بحث می‌کنند، او به آرامی می‌گوید:
                    </p>
                    <p className="italic text-gray-700">
                        "تا این سه مورد نهایی نشه، نمی‌تونیم وارد فاز اجرا بشیم."
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="دیدگاه‌های رفتاری فرد SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        فرد دارای الگوی  SCD جهان را از فیلتر منطق، نظم، واقع‌گرایی، و تعامل آرام می‌بیند. او نه مثل افراد High D  دنیا را صحنه نبرد می‌بیند، نه مثل High I  آن را جشن رنگارنگ. برای  SCD، دنیا جایی است که باید به آن ساختار بخشید، از آشفتگی دوری کرد، و کارها را درست، با کیفیت و با احترام انجام داد.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نحوه نگاه SCD به کار، روابط و محیط اطراف">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۱. نگاه به کار: «با ثبات، منطقی، دقیق»</h3>
                    <ul className="list-disc list-inside space-y-2">
                        <li>کار برای او یک تعهد بلندمدت است، نه صرفاً یک وظیفه لحظه‌ای.</li>
                        <li>اگر کاری بی‌نظم، بی‌چارچوب یا ناپایدار باشد، او ناخودآگاه عقب‌نشینی می‌کند.</li>
                        <li>عاشق ایجاد روال‌ منظم، استانداردسازی، و اصلاح سازوکارهای ناکارآمد است.</li>
                    </ul>
                    <p>
                        مثال: اگر در یک تیم محتوایی، وظیفه تولید مقاله دارد، پس از مدتی احتمالاً یک شِیت استاندارد برای تیتر، پاراگراف‌بندی، CTA  و منابع ایجاد می‌کند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نحوه نگاه SCD به کار، روابط و محیط اطراف">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۲. نگاه به روابط کاری: «محترمانه، قابل پیش‌بینی، بدون بازی»</h3>
                    <ul className="list-disc list-inside space-y-2">
                        <li>در روابط خود، به‌شدت روی صداقت، نظم، وفاداری و مرزها تأکید دارد.</li>
                        <li>اهل سیاست‌بازی یا رفتارهای خاکستری نیست. اگر از کسی بی‌احترامی یا آشفتگی ببیند، ترجیح می‌دهد فاصله بگیرد تا درگیر شود.</li>
                        <li>روابط کاری خوب را این‌طور می‌بیند: "تو وظیفه‌ات را انجام بده، من هم انجام می‌دهم، و به هم احترام می‌گذاریم."</li>
                    </ul>
                    <p>
                        جمله‌ای که ممکن است از او بشنوید:
                    </p>
                    <p className="italic text-gray-700">
                        "من از کار با فلانی خوشم میاد چون همیشه سر وقت میاد، مؤدب صحبت می‌کنه، و کارش دقیق و حرفه‌ایه."
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نحوه نگاه SCD به کار، روابط و محیط اطراف">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۳. نگاه به تغییر: «قابل‌پذیرش، اما با تحلیل و زمان»</h3>
                    <ul className="list-disc list-inside space-y-2">
                        <li>تغییر اگر از قبل توضیح داده شود، منطقی باشد و فرصت تطبیق داده شود ، برای او قابل پذیرش است.</li>
                        <li>اما اگر تغییر ناگهانی، بی‌منطق یا بدون مشارکت او باشد، مقاومت یا عقب‌نشینی می‌کند.</li>
                    </ul>
                    <p>
                        مثال: اگر قرار باشد سامانه‌ای جدید در شرکت راه‌اندازی شود، او کسی است که می‌پرسد:
                    </p>
                    <p className="italic text-gray-700">
                        "دلیل این تغییر چی بوده؟ آموزش‌هامون کیه؟ باگ‌هاش بررسی شده؟"
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نحوه نگاه SCD به کار، روابط و محیط اطراف">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۴. نگاه به تیم:</h3>
                    <p className="italic text-gray-700">
                        «تیمی موفق است که ساختار، صمیمیت و کارآمدی را با هم داشته باشد»
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>از تیم‌های پر سر و صدا و بی‌برنامه لذت نمی‌برد.</li>
                        <li>دوست دارد تیمش  تعادل بین دقت و همکاری را حفظ کند.</li>
                        <li>اگر تیمی دارد، تلاش می‌کند با الگوسازی آرام، آن‌ها را به سمت نظم، احترام، و هدفمندی ببرد.</li>
                    </ul>
                    <p>
                        مثال: در یک پروژه داوطلبانه، ممکن است quietly  مدیریت کند و تمام منابع، زمان‌ها و اولویت‌ها را در یک فایل Google Sheet  دقیق ثبت کرده باشد  ،  حتی اگر بقیه تیم خیلی جدی نباشند!
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهاد فیلم برای درک بهتر دیدگاه SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        The Post پست – شخصیت "کاترین گراهام" با بازی مریل استریپ
                    </p>
                    <p>
                        زنی که با آرامش، تحلیل، وقار و نهایت دقت تصمیم‌گیری می‌کند؛ حتی در سخت‌ترین شرایط، ترجیح می‌دهد از رویارویی مستقیم بپرهیزد، اما در لحظه درست، قاطعانه و با منطق عمل می‌کند. نمونه‌ای کلاسیک از شخصیت  SCD در موقعیت رهبری.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="اوقات فراغت در الگوی رفتاری SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        افراد با تیپ رفتاری  SCD معمولاً در اوقات فراغت به دنبال آرامش، نظم ذهنی، و فعالیت‌های معنادار با حداقل تنش و شلوغی هستند. تفریحات آن‌ها اغلب کم‌ریسک، تأمل‌برانگیز، و همراه با عمق یا نظم شخصی است.
                    </p>
                    <p>
                        در واقع، برایشان مهم نیست که وقت آزاد پر از هیجان باشد؛ مهم این است که کنترل، کیفیت و تعادل در آن وجود داشته باشد.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ویژگی‌های شاخص اوقات فراغت افراد SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۱. علاقه به طبیعت، خلوت و فعالیت‌های آرام</h3>
                    <p>
                        فعالیت‌هایی مثل پیاده‌روی در طبیعت، مطالعه در فضاهای خلوت، رسیدگی به گل‌وگیاه، گوش دادن به موسیقی کلاسیک یا سازهای آرام برایشان بسیار لذت‌بخش است.
                    </p>
                    <p>
                        مثال: آخر هفته ایده‌آل یک فرد  SCD ممکن است شامل یک صبحانه در بالکن، رسیدگی به گیاهان، مطالعه یک کتاب غیرداستانی یا تحلیل‌محور، و تماشای یک مستند باشد.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ویژگی‌های شاخص اوقات فراغت افراد SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۲. فراغت ساختاریافته؛ تفریح باید برنامه‌دار باشد!</h3>
                    <p>
                        برای فرد  SCD حتی تفریح هم باید برنامه‌ریزی‌شده باشد. تصمیم ناگهانی برای رفتن به کنسرت یا سفر بدون آمادگی، او را مضطرب می‌کند.
                    </p>
                    <p>
                        جمله متداول از او:
                    </p>
                    <p className="italic text-gray-700">
                        «اگر از دو هفته قبل بدونم کجا می‌ریم و برنامه‌مون چیه، با دل و جون میام.»
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ویژگی‌های شاخص اوقات فراغت افراد SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۳. علاقه به فعالیت‌های ذهنی یا دستی منظم</h3>
                    <p>
                        SCDها از کارهایی لذت می‌برند که نظم، تکرار و ساختار در آن‌ها وجود دارد ؛ مثل:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>طراحی با دقت</li>
                        <li>نجاری سبک یا کارهای فنی در منزل</li>
                        <li>پازل یا بازی‌های تحلیلی</li>
                        <li>جدول، شطرنج، سودوکو</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="ویژگی‌های شاخص اوقات فراغت افراد SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. وقت‌گذرانی با افراد خاص و قابل پیش‌بینی</h3>
                    <p>
                        افراد  SCD معمولاً دایره دوستان محدودی دارند که  قابل اعتماد، باثبات و بااحترام هستند. ترجیح می‌دهند با این دوستان وقت بگذرانند تا در جمع‌های بزرگ و پر از انرژی متغیر حضور داشته باشند.
                    </p>
                    <p>
                        مثال: ترجیح می‌دهد با یک دوست صمیمی قدیمی ناهار بخورد تا اینکه به یک دورهمی ۲۰ نفره برود.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهاد فیلم یا فعالیت">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        فیلم پیشنهادی: The Secret Life of Walter Mitty
                    </p>
                    <p>
                        زندگی خصوصی والتر میتی
                    </p>
                    <p>
                        این فیلم درباره مردی ساکت و منظم است که آرام‌آرام با حفظ ریشه‌های شخصیتی خود، شروع به تجربه دنیای بیرون می‌کند. الهام‌بخش برای  SCDهایی که گاهی نیاز دارند از دایره امن بیرون بیایند، بدون اینکه نظم درونی‌شان از بین برود.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهادات برای بهبود عملکرد SCD">
                <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>تصمیم‌گیری در الگوی رفتاری SCD</h3>
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        تصمیم‌گیری برای افراد با الگوی  SCD معمولاً فرایندی تحلیلی، تدریجی، و سنجیده است.
                    </p>
                    <p>
                        آن‌ها به سرعت تصمیم نمی‌گیرند، اما اگر تصمیمی بگیرند، احتمال تغییر آن کم است مگر اینکه شواهد کافی ارائه شود.
                    </p>
                    <p>
                        آن‌ها می‌خواهند "تصمیم درست" بگیرند نه "تصمیم سریع"، و این نگرش می‌تواند هم مزیت باشد و هم مانع.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ویژگی‌های تصمیم‌گیری در افراد SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۱. کند اما دقیق</h3>
                    <p>
                        افراد  SCD ابتدا سعی می‌کنند اطلاعات کافی جمع کنند، جوانب مختلف را بسنجند، و خطرات احتمالی را شناسایی کنند.
                    </p>
                    <p>
                        مثال: اگر بخواهند در یک دوره آموزشی ثبت‌نام کنند، حتماً مدرس، سرفصل‌ها، نظرات شرکت‌کنندگان قبلی و قیمت‌ها را بررسی می‌کنند، نه اینکه صرفاً به توصیه دیگران اعتماد کنند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ویژگی‌های تصمیم‌گیری در افراد SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۲. تأثیرپذیر از قواعد و چارچوب‌ها</h3>
                    <p>
                        اگر قوانینی، مقررات، یا ساختاری مشخص برای تصمیم وجود داشته باشد،  SCD بسیار راحت‌تر تصمیم می‌گیرد.
                    </p>
                    <p>
                        مثال: اگر یک فرآیند انتخاب شغل شامل فرم‌ها، امتیازبندی و تحلیل باشد، او با خیال راحت جلو می‌رود. اما اگر انتخاب فقط بر اساس "احساس" یا "انگیزه" باشد، مردد و مضطرب می‌شود.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ویژگی‌های تصمیم‌گیری در افراد SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۳. اجتناب از ریسک‌های سریع یا تصمیمات احساسی</h3>
                    <p>
                        حتی اگر مزایای زیادی در تصمیمی وجود داشته باشد، اگر پر از ابهام و عدم قطعیت باشد، فرد  SCD عقب‌نشینی می‌کند.
                    </p>
                    <p>
                        جمله رایج از او:
                    </p>
                    <p className="italic text-gray-700">
                        «بذار یه کم بیشتر فکر کنم، باید جوانبشو ببینم.»
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ویژگی‌های تصمیم‌گیری در افراد SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۴. تمایل به گرفتن مشورت تحلیلی نه صرفاً توصیه دوستانه</h3>
                    <p>
                        افراد  SCD از مشورت گرفتن استقبال می‌کنند، ولی نه با هرکسی. آن‌ها ترجیح می‌دهند از کسانی مشورت بگیرند که:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>ساختار ذهنی منظم دارند</li>
                        <li>تجربه قابل استناد دارند</li>
                        <li>تحلیل‌گرند، نه فقط انگیزشی‌گو</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="چالش رایج">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        گاهی به‌دلیل دقت زیاد در تصمیم‌گیری و ترس از خطا ، وارد فاز «فلج تحلیلی» Analysis Paralysis  می‌شوند و تصمیم‌گیری به‌تعویق می‌افتد یا بی‌نتیجه می‌ماند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="راهکارهایی برای بهبود تصمیم‌گیری در افراد SCD">
                <div className="overflow-x-auto">
                    <table className="w-full text-right border border-gray-300 border-collapse">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="border border-gray-300 p-3 font-semibold">چالش</th>
                                <th className="border border-gray-300 p-3 font-semibold">راهکار پیشنهادی</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border border-gray-300 p-3">تأخیر در تصمیم‌گیری</td>
                                <td className="border border-gray-300 p-3">استفاده از تکنیک‌های تصمیم‌گیری سریع مثل ماتریس آیزنهاور یا فیلتر دو مرحله‌ای</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">ترس از اشتباه</td>
                                <td className="border border-gray-300 p-3">تمرین تصمیم‌گیری در موقعیت‌های کم‌ریسک شروع با تصمیمات کوچک</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">جمع‌آوری بیش‌ازحد اطلاعات</td>
                                <td className="border border-gray-300 p-3">محدود کردن منابع تحقیق به ۲ یا ۳ منبع معتبر</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-3">نداشتن اولویت‌بندی</td>
                                <td className="border border-gray-300 p-3">استفاده از مدل ۸۰/۲۰ برای انتخاب مهم‌ترین گزینه</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهاد تمرین یا سناریو">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        در یک پروژه فرضی، تیمی متشکل از چهار نفر باید در ۱۵ دقیقه بین دو گزینه مهم یکی را انتخاب کند. فرد  SCD باید با فشار زمان، اطلاعات ناقص و مخالفت اعضا کنار بیاید و تصمیم را نهایی کند.
                    </p>
                    <p>
                        هدف تمرین: تجربه کردن اینکه گاهی تصمیم «نسبتاً خوب در زمان مناسب»، بهتر از تصمیم «کامل اما دیر» است.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهادات عملی برای بهبود عملکرد افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        افراد با الگوی رفتاری  SCD معمولاً دارای دقت بالا، پایبندی به اصول، وفاداری، و نگرش منطقی هستند، اما در کنار این نقاط قوت، محدودیت‌هایی نیز دارند که در صورت مدیریت نشدن، می‌تواند باعث کاهش بهره‌وری یا خستگی ذهنی شود.
                    </p>
                    <p>
                        در این بخش، پیشنهادات کاربردی جهت افزایش عملکرد، تعادل در رفتار، و ارتقای کیفیت زندگی کاری و فردی فرد  SCD ارائه می‌شود.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهادات عملی برای بهبود عملکرد افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۱. تمرین تصمیم‌گیری سریع در موقعیت‌های کم‌ریسک</h3>
                    <p>
                        چرا؟ زیرا این تیپ معمولاً دچار فلج تحلیلی می‌شود.
                    </p>
                    <p>
                        تمرین: مثلاً در ۳۰ ثانیه از بین دو فعالیت تفریحی یکی را انتخاب کن و همان را انجام بده.
                    </p>
                    <p>
                        هدف: تمرین "پذیرش کافی بودن" به جای "در جستجوی کامل بودن".
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهادات عملی برای بهبود عملکرد افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۲. کاهش کمال‌گرایی و تمرین اعتماد به مسیر</h3>
                    <p>
                        افراد  SCD تمایل دارند تا زمانی که احساس نکنند همه چیز بی‌نقص است، کاری را شروع نکنند.
                    </p>
                    <p>
                        راهکار: "شروع ناقص، بهتر از سکون کامل است."
                    </p>
                    <p>
                        مثال: اگر قراره محتوایی بنویسد، نوشتن نسخه اول بدون نگرانی از کیفیت نهایی را تمرین کند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهادات عملی برای بهبود عملکرد افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۳. پرورش جسارت و انعطاف‌پذیری در مواجهه با تغییر</h3>
                    <p>
                        چرا؟ تغییرات ناگهانی اضطراب زیادی برایشان دارد.
                    </p>
                    <p>
                        راهکار: تمرین "انعطاف کوچک" مثل تغییر ساعت رفت‌وآمد، تغییر محل نشستن، یا اجرای یک ایده جدید بدون تضمین موفقیت.
                    </p>
                    <p>
                        جمله تأکیدی برای خود:
                    </p>
                    <p className="italic text-gray-700">
                        من می‌توانم بدون از دست دادن کنترل، با تغییر همراه شوم.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهادات عملی برای بهبود عملکرد افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۴. تقویت توانایی «نه گفتن» و تعیین مرزهای ارتباطی</h3>
                    <p>
                        به‌خاطر شخصیت وفادار و همدل‌شان، گاهی بیش از حد از خود مایه می‌گذارند.
                    </p>
                    <p>
                        تمرین عملی: در یک هفته آینده، در دو موقعیت غیرضروری با احترام "نه" بگوید و ببینید دنیا تمام نمی‌شود!
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهادات عملی برای بهبود عملکرد افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۵. همکاری با تیپ‌های مکمل برای حفظ تعادل رفتاری</h3>
                    <p>
                        افراد  SCD بهتر است در کنار خود از افراد با تیپ‌های مکمل مثل DI ، IS  یا IC  بهره ببرند تا در تصمیم‌گیری‌های پرریسک، خلاقیت، انرژی یا سرعت، دچار نقصان نشوند.
                    </p>
                    <p>
                        مزیت تیمی:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>DI  → جسارت</li>
                        <li>IS  → انرژی مثبت</li>
                        <li>IC  → تفکر انتقادی در محیط امن</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهادات عملی برای بهبود عملکرد افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۶. افزایش مهارت در مدیریت زمان و اولویت‌بندی</h3>
                    <p>
                        از آنجایی که گاهی در جزئیات غرق می‌شوند، زمان از دستشان درمی‌رود.
                    </p>
                    <p>
                        ابزار پیشنهادی:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>قانون ۲ دقیقه برای شروع کارهای کوچک</li>
                        <li>ماتریس آیزنهاور مهم-فوری</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهادات عملی برای بهبود عملکرد افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۷. دریافت بازخورد منظم برای رشد تدریجی</h3>
                    <p>
                        فرد  SCD وقتی بازخورد دقیق، محترمانه و سازنده دریافت کند، آن را جدی می‌گیرد و با آن رشد می‌کند.
                    </p>
                    <p>
                        توصیه به مدیران یا مربیان:
                    </p>
                    <p>
                        بازخورد را مستند، مرحله‌ای و همراه با راه‌حل ارائه کنید.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="پیشنهاد فیلم">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        A Beautiful Mind – شخصیت جان نش
                    </p>
                    <p>
                        یک فرد تحلیل‌گر، محتاط، با دقت بالا و ساختار ذهنی  SCD که با چالش‌های درونی و بیرونی روبه‌روست و آرام‌آرام یاد می‌گیرد که باید گاهی مسیر را تجربه کرد، حتی بدون کنترل کامل.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="رمز موفقیت افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        رمز موفقیت افراد با تیپ رفتاری  SCD در این است که بتوانند:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>به دقت و نظم درونی خود افتخار کنند،</li>
                        <li>اما در عین حال جسارت کافی برای «عمل» را نیز پرورش دهند.</li>
                    </ul>
                    <p>
                        SCDها زمانی شکوفا می‌شوند که بین برنامه‌ریزی دقیق و اقدام هوشمندانه تعادل برقرار کنند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="اصول طلایی موفقیت برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. اقدام‌گرایی بدون وسواس</h3>
                    <p className="italic text-gray-700">
                        «کمال‌گرایی دشمن عمل است.»
                    </p>
                    <p>
                        فرد  SCD باید بیاموزد که گاهی «خوب انجام دادن در زمان مناسب» بهتر از «عالی انجام دادن دیرهنگام» است.
                    </p>
                    <p>
                        تمرین: پروژه‌ای را شروع کنید حتی اگر همه اطلاعات صددرصد کامل نیست. سپس در طول مسیر اصلاحش کنید.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="اصول طلایی موفقیت برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. تقویت شهامت در تصمیم‌گیری</h3>
                    <p>
                        رمز رشد شما در این است که در موقعیت‌هایی که اطلاعات کامل نیست هم بتوانید تصمیم بگیرید.
                    </p>
                    <p>
                        یاد بگیرید با عدم قطعیت هم زندگی کنید.
                    </p>
                    <p>
                        جمله کلیدی:
                    </p>
                    <p className="italic text-gray-700">
                        «گاهی نمی‌دانم چه خواهد شد، اما با آگاهی و تعهد پیش می‌روم.»
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="اصول طلایی موفقیت برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. تمرکز بر نتیجه، نه فقط فرآیند</h3>
                    <p>
                        افراد  SCD ممکن است در گیر و دار برنامه‌ها و تحلیل‌ها، از هدف اصلی فاصله بگیرند.
                    </p>
                    <p>
                        باید یاد بگیرند نقطه پایان را تعریف و پیگیری کنند.
                    </p>
                    <p>
                        تمرین عملی:
                    </p>
                    <p>
                        برای هر پروژه، یک «تعریف مشخص از نتیجه» بنویسید و هفته‌ای یک بار آن را بررسی کنید.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="اصول طلایی موفقیت برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تعادل بین تحلیل و شهود</h3>
                    <p>
                        افراد  SCD به ذهن منطقی و ساختارگرا تکیه دارند. اما گاهی صدای درون شهود نیز می‌تواند راهنما باشد.
                    </p>
                    <p>
                        پیشنهاد:
                    </p>
                    <p>
                        در تصمیم‌های شخصی یا احساسی، از خود بپرسید:
                    </p>
                    <p className="italic text-gray-700">
                        «اگر فقط به احساس قلبی‌ام گوش دهم، چه می‌کنم؟»
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="اصول طلایی موفقیت برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. اعتمادسازی با دیگران، نه فقط وظایف</h3>
                    <p>
                        رمز موفقیت بلندمدت افراد  SCD در محیط کار، ایجاد ارتباطات حرفه‌ای همراه با اعتماد متقابل است.
                    </p>
                    <p>
                        نظم و تحلیل عالی هستند، اما تعامل انسانی عامل ماندگاری شماست.
                    </p>
                    <p>
                        تمرین:
                    </p>
                    <p>
                        در جلسات تیمی، پیش از ورود به بحث کاری، ۲ دقیقه تعامل انسانی احوال‌پرسی یا گفت‌وگوی کوتاه را تمرین کنید.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="اصول طلایی موفقیت برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. ذهن باز نسبت به بازخورد</h3>
                    <p>
                        رمز موفقیت در یادگیری مستمر، پذیرش بازخورد بدون حالت تدافعی است.
                    </p>
                    <p>
                        افراد  SCD چون به ساختار و کیفیت اهمیت می‌دهند، باید یاد بگیرند بازخورد را ابزار رشد ببینند، نه تهدید.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="اصول طلایی موفقیت برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. جسارت در بروز احساسات</h3>
                    <p>
                        در دنیای تعاملات انسانی، صرفاً تحلیل و منطق کافی نیست. فرد  SCD  باید یاد بگیرد احساسات خود را نیز گاه‌به‌گاه ابراز کند تا دیگران او را سرد یا جدا از جمع تلقی نکنند.
                    </p>
                    <p>
                        جمله تمرینی:
                    </p>
                    <p className="italic text-gray-700">
                        «من می‌تونم در عین نظم و عقلانیت، احساس هم داشته باشم.»
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="فیلم پیشنهادی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        The King's Speech  2010
                    </p>
                    <p>
                        داستان پادشاهی که با وجود لکنت زبان و اضطراب، در اوج فشار جهانی باید سخنرانی کند. با کمک مربی، به قدرتی آرام، اما قاطع و مؤثر می‌رسد.
                    </p>
                    <p>
                        نمونه بی‌نظیری از رهایی تدریجی از محافظه‌کاری به‌سمت اقتدار درونی.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نحوه تعدیل و تقویت لایه‌های رفتاری در تیپ SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        افراد با تیپ  SCD معمولا دارای ترکیبی از ثبات S ، دقت بالا C  و کمی تسلط D  هستند. اما برای تعادل بهتر در عملکرد شخصی و حرفه‌ای، لازم است برخی لایه‌ها را تعدیل یا تقویت کنند. در اینجا به‌طور دقیق توضیح می‌دهیم که چگونه:
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نحوه تعدیل و تقویت لایه‌های رفتاری در تیپ SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۱. تقویت لایه D  تسلط و رهبری</h3>
                    <p>
                        چالش تیپ  SCD : محافظه‌کاری، کندی در تصمیم‌گیری، اجتناب از برخورد و عدم قاطعیت در مواقع بحرانی
                    </p>
                    <p>
                        راهکارهای تقویتی: تمرین "تصمیم‌گیری تحت فشار": در موقعیتی روزانه مثلاً خرید، مسیر رفتن، یا تصمیم شغلی کوچک در زمان محدود تصمیم بگیرید.
                    </p>
                    <p>
                        از جمله‌های قدرت‌بخش استفاده کنید:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>«همین امروز اقدام می‌کنم.»</li>
                        <li>«با اطمینان جلو می‌رم.»</li>
                    </ul>
                    <p>
                        الگوبرداری از افراد High D  در اطراف یا رسانه‌ها مثلاً استیو جابز، ایلان ماسک، یا کاراکتر فرماندهان در فیلم‌ها
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نحوه تعدیل و تقویت لایه‌های رفتاری در تیپ SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۲. تقویت لایه I  انرژی، ارتباطات، خلاقیت</h3>
                    <p>
                        چالش تیپ  SCD : کم‌حرف بودن، جدی بودن بیش از حد، ناتوانی در تعامل احساسی، سخت بودن بروز هیجانات
                    </p>
                    <p>
                        راهکارهای تقویتی: در جمع‌های دوستانه یا کاری، هر روز حداقل یک بار یک داستان شخصی یا شوخی سالم مطرح کنید. صدای خود را ضبط کنید هنگام تعریف یک ماجرا، و لحن را بررسی و اصلاح کنید.
                    </p>
                    <p>
                        بیشتر از واژگان گرم و احساسی استفاده کنید مثل: «چه حس خوبی»، «از دیدنت خوشحالم»، «دمت گرم».
                    </p>
                    <p>
                        مشارکت در بازی‌های گروهی، پانتومیم، یا حتی تماشای تئاتر کمدی برای فعال‌سازی بخش هیجانی مغز
                    </p>
                    <p>
                        پیشنهاد فیلم: The Intern شخصیت رابرت دنیرو یک فرد بسیار ساختاری است که یاد می‌گیرد با نشاط، شوخی و تعاملات گرم در یک استارتاپ مدرن ارتباط برقرار کند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نحوه تعدیل و تقویت لایه‌های رفتاری در تیپ SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۳. تعدیل بیش‌ازحد بودن در لایه S و C</h3>
                    <p>
                        تیپ  SCD گاهی آن‌قدر در نظم، تحلیل، ثبات و در نظر گرفتن همه چیز غرق می‌شود که:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>انرژی تیم را می‌کُشد</li>
                        <li>فرصت‌ها را از دست می‌دهد</li>
                        <li>دچار تأخیر در اجرا می‌شود</li>
                        <li>دچار وسواس فکری می‌شود</li>
                    </ul>
                    <p>
                        راهکارهای تعدیل:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>تمرین "شروع قبل از آمادگی کامل"</li>
                        <li>تعیین ددلاین برای تحلیل: مثلاً فقط ۲۰ دقیقه برای بررسی موضوع وقت بگذار</li>
                        <li>مشورت با افراد پرانرژی، جسور یا تیپ I  برای تعادل‌بخشی به برنامه‌ات</li>
                        <li>استفاده از عبارت‌های تسهیل‌گر مثل: «کافی باشه، حرکت کنیم.» «بذار تو عمل ببینیم چی میشه.»</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="جملات پیشنهادی برای تقویت خودباوری و عمل‌گرایی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <ul className="list-disc list-inside space-y-2">
                        <li>«عمل امروز، از ایده عالی فردا مهم‌تره.»</li>
                        <li>«همیشه لازم نیست همه‌چی کامل باشه تا شروع کنم.»</li>
                        <li>«تو عمله که بهتر می‌فهمم، نه فقط در فکر.»</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="تمرین عملی ترکیبی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        یک پروژه یا تصمیم رو بنویس:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>چقدر برنامه‌ریزی C  نیاز داره؟</li>
                        <li>چقدر پایداری و پیگیری S ؟</li>
                        <li>چقدر جسارت و عمل D ؟</li>
                        <li>چقدر انرژی و ارتباط I ؟</li>
                    </ul>
                    <p>
                        اگر توازن نداره، ببین کدوم بخش رو باید بالا ببری. این تمرین به خودآگاهی ترکیبی بسیار کمک می‌کنه.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="دانش و مهارت‌های مورد نیاز برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        تیپ شخصیتی  SCD ترکیب ثبات، دقت، و کمی تسلط برای موفقیت بیشتر در زندگی حرفه‌ای و شخصی، نیاز دارد که مجموعه‌ای از مهارت‌ها را در چند حوزه کلیدی به شکل هدفمند تقویت کند:
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="دانش و مهارت‌های مورد نیاز برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۱. مهارت‌های تصمیم‌گیری و اقدام سریع</h3>
                    <p>
                        افراد  SCD معمولاً برای تصمیم‌گیری نیاز به اطلاعات کامل و تحلیل فراوان دارند، که گاهی باعث تأخیر یا از دست دادن فرصت‌ها می‌شود.
                    </p>
                    <p>
                        مهارت‌های پیشنهادی:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>تصمیم‌گیری تحت فشار Decision Making under Pressure</li>
                        <li>اولویت‌بندی تصمیم‌ها Decision Prioritization</li>
                        <li>تفکر در شرایط عدم قطعیت Thinking in Uncertainty</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="دانش و مهارت‌های مورد نیاز برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۲. مدیریت زمان و انرژی</h3>
                    <p>
                        با توجه به وسواس و دقت بالا، ممکن است زمان زیادی صرف جزئیات شود.
                    </p>
                    <p>
                        مهارت‌های پیشنهادی:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>زمان‌بندی بر اساس اولویت Timeboxing &amp; Prioritization</li>
                        <li>تکنیک پومودورو برای مدیریت تمرکز</li>
                        <li>مدیریت انرژی روزانه Peak Performance Hours</li>
                    </ul>
                    <p>
                        اپلیکیشن پیشنهادی: TickTick یا Notion  برای برنامه‌ریزی روزانه
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="دانش و مهارت‌های مورد نیاز برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۳. مهارت‌های ارتباط مؤثر</h3>
                    <p>
                        برای افراد  SCD که اغلب جدی، کم‌صحبت و ساختارگرا هستند، تعاملات گرم و صمیمی می‌تواند چالش‌برانگیز باشد.
                    </p>
                    <p>
                        مهارت‌های پیشنهادی:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>هوش هیجانی Emotional Intelligence</li>
                        <li>مهارت‌های گفتگوهای دشوار Difficult Conversations</li>
                        <li>مهارت همدلی و شنیدن فعال</li>
                    </ul>
                    <p>
                        فیلم پیشنهادی: Bridge of Spies  – رابطه یک وکیل تحلیلی و دقیق با مأموران و موکل خود
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="دانش و مهارت‌های مورد نیاز برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۴. مهارت در ایجاد نوآوری و پذیرش ریسک</h3>
                    <p>
                        افراد  SCD تمایل زیادی به ثبات دارند؛ باید جسارت مواجهه با نوآوری را پیدا کنند.
                    </p>
                    <p>
                        مهارت‌های پیشنهادی:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>تفکر طراحی Design Thinking</li>
                        <li>حل مسئله خلاقانه Creative Problem Solving</li>
                        <li>تحلیل ریسک و فرصت</li>
                    </ul>
                    <p>
                        کتاب پیشنهادی:
                    </p>
                    <p>
                        Start Before You’re Ready قبل از اینکه آماده باشید، شروع کنید.  اثر Mike King
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="دانش و مهارت‌های مورد نیاز برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۵. مهارت‌های رهبری و تعامل با تیپ‌های متفاوت</h3>
                    <p>
                        SCDها باید یاد بگیرند چگونه با تیپ‌های High I  پر انرژی، High D  سریع‌تصمیم، و High S  احساس‌محور تعامل سازنده داشته باشند.
                    </p>
                    <p>
                        مهارت‌های پیشنهادی:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>تطبیق رفتاری در تیم‌های چندسبکی Behavioral Adaptation</li>
                        <li>هدایت تیم‌های متنوع Leading Diverse Teams</li>
                        <li>هنر تفویض و اعتماد به دیگران Delegation &amp; Trust Building</li>
                    </ul>
                    <p>
                        تمرین: در هر جلسه گروهی، سعی کنید حداقل با یک نفر با تیپ رفتاری متفاوت ارتباط نزدیک‌تری برقرار کنید.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="دانش و مهارت‌های مورد نیاز برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۶. مهارت‌های کنترل کمال‌گرایی</h3>
                    <p>
                        کمال‌گرایی کنترل‌نشده باعث فرسودگی شغلی و ذهنی می‌شود. برای تیپ  SCD، مدیریت این تمایل بسیار مهم است.
                    </p>
                    <p>
                        مهارت‌های پیشنهادی:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>پذیرش «کافی بودن» به جای «عالی بودن»</li>
                        <li>تمرین اقدام ناقص Imperfect Action</li>
                        <li>مدیریت ذهن وسواسی</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="دانش و مهارت‌های مورد نیاز برای SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۷. مهارت هدف‌گذاری و ارزیابی پیشرفت</h3>
                    <p>
                        با ذهن تحلیلی و ساختاری، اگر  SCD هدف‌گذاری مؤثر و شاخص‌محور را یاد بگیرد، بسیار موفق‌تر خواهد بود.
                    </p>
                    <p>
                        مهارت‌های پیشنهادی:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>OKR Objectives &amp; Key Results</li>
                        <li>KPI های فردی و تیمی</li>
                        <li>تحلیل پیشرفت و بازنگری مستمر</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="مشاغل مناسب برای افراد با الگوی رفتاری SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        ترکیبی از ثبات S  ،  دقت و تحلیل C  و میزانی از تسلط D
                    </p>
                    <p>
                        افراد با این تیپ رفتاری، معمولاً دارای ویژگی‌های زیر هستند:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>ساختارمند، دقیق، قابل‌اعتماد و پیگیر</li>
                        <li>اهل تحلیل، با تمرکز بالا بر جزئیات و فرایند</li>
                        <li>دارای نظم درونی، وفادار و اهل استمرار</li>
                        <li>اهل اقدام هدفمند، بدون هیجان‌زدگی</li>
                        <li>دارای حس مسئولیت و تمایل به نتیجه‌گرایی</li>
                    </ul>
                    <p>
                        با توجه به این ویژگی‌ها، مشاغلی که ترکیبی از تحلیل، نظم، همکاری مؤثر و در عین حال اجرا و رهبری پروژه‌ها دارند، برای آن‌ها بسیار مناسب‌اند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="مشاغل پیشنهادی برای افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        <strong>۱. مدیر کنترل کیفیت Quality Control Manager</strong>
                    </p>
                    <p>
                        چرا مناسب است؟
                    </p>
                    <p>
                        نیاز به دقت، پیگیری، تحلیل‌گری، استانداردسازی و مسئولیت‌پذیری بالا دارد.
                    </p>
                    <p>
                        <strong>۲. مدیر پروژه‌های فنی یا اداری Project Manager</strong>
                    </p>
                    <p>
                        چرا مناسب است؟
                    </p>
                    <p>
                        تیپ  SCD توانایی برنامه‌ریزی، پایش، هدایت آرام و منطقی تیم‌ها را دارد و می‌تواند پروژه را با ساختار دقیق به سرانجام برساند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="مشاغل پیشنهادی برای افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        <strong>3. حسابرس یا تحلیل‌گر مالی Auditor / Financial Analyst</strong>
                    </p>
                    <p>
                        چرا مناسب است؟
                    </p>
                    <p>
                        دقت در جزئیات، نظم در تحلیل، مهارت‌های عددی و ثبات بالا برای پیگیری اطلاعات و گزارش‌گیری
                    </p>
                    <p>
                        <strong>۴. مشاور منابع انسانی یا طراح فرآیندهای سازمانی</strong>
                    </p>
                    <p>
                        چرا مناسب است؟
                    </p>
                    <p>
                        SCDها توان ایجاد ساختارهای باثبات، طراحی فرایندهای HR  و ارزیابی رفتارها را دارند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="مشاغل پیشنهادی برای افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        <strong>۵. مدیر دفتر مدیرعامل Executive Assistant / Office Manager</strong>
                    </p>
                    <p>
                        چرا مناسب است؟
                    </p>
                    <p>
                        این شغل به وفاداری، کنترل بالا، ارتباط مؤثر، سرعت عمل و پیگیری کامل نیاز دارد؛ همه در حوزه‌ی توانمندی تیپ  SCD .
                    </p>
                    <p>
                        <strong>۶. برنامه‌ریز لجستیک یا تدارکات Logistics Planner</strong>
                    </p>
                    <p>
                        چرا مناسب است؟
                    </p>
                    <p>
                        برنامه‌ریزی دقیق، ارتباط با تأمین‌کننده‌ها، پیگیری به‌موقع و مستندسازی فرایندها از نقاط قوت این تیپ هستند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="مشاغل پیشنهادی برای افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        <strong>۷. طراح سیستم‌های اطلاعاتی یا ERP</strong>
                    </p>
                    <p>
                        چرا مناسب است؟
                    </p>
                    <p>
                        ساختارگرایی بالا، نظم تحلیلی، علاقه به نظم سازمانی و درک منطقی از اطلاعات برای توسعه سیستم‌های مدیریتی و مالی بسیار مفید است.
                    </p>
                    <p>
                        <strong>۸. تحلیل‌گر داده Data Analyst / BI Specialist</strong>
                    </p>
                    <p>
                        چرا مناسب است؟
                    </p>
                    <p>
                        نیاز به تفکر تحلیلی، دقت، تمرکز بر جزئیات، تفسیر داده‌ها و تولید گزارش‌های قابل اعتماد
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="مشاغل پیشنهادی برای افراد با الگوی SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        <strong>۹. مدیر عملیات Operations Manager</strong>
                    </p>
                    <p>
                        چرا مناسب است؟
                    </p>
                    <p>
                        این نقش نیاز به دید کلی و عمیق، ساختارسازی، تحلیل روندها، مدیریت افراد و کنترل منابع دارد.
                    </p>
                    <p>
                        <strong>۱۰. مشاور یا مدیر استانداردسازی و تضمین کیفیت</strong>
                    </p>
                    <p>
                        چرا مناسب است؟
                    </p>
                    <p>
                        SCDها بسیار مناسب برای طراحی و پیاده‌سازی استانداردها، مستندسازی، بازرسی و نظارت‌های پیوسته هستند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکته کاربردی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        افراد  SCD ممکن است علاقه‌ای به کارهای بسیار پُرریسک یا بی‌برنامه نداشته باشند؛ بنابراین مشاغل پر از تنش، تصمیمات لحظه‌ای یا بدون ساختار مثل فروشندگی خیابانی، تریدر کوتاه‌مدت، مجری شبکه زنده و... مناسب‌شان نیست.
                    </p>
                    <p>
                        پیشنهاد خودشناسی مکمل:
                    </p>
                    <p>
                        در کنار DISC، استفاده از تست رغبت شغلی هالند و تحلیل SWOT  شخصیتی برای انتخاب دقیق‌تر مسیر شغلی، پیشنهاد می‌شود.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="همسر مناسب برای افراد با الگوی SCD و نحوه ارتباط مؤثر با او">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        افراد دارای تیپ شخصیتی  SCD افرادی دقیق، آرام، تحلیل‌گر، بااحساس مسئولیت بالا و خواهان ثبات در روابط هستند. آن‌ها نه اهل شتاب‌زدگی‌اند و نه هیجان‌های بی‌ثبات. از طرفی به استانداردها، کیفیت، ساختار و وفاداری در رابطه بسیار پایبندند.
                    </p>
                    <p>
                        در زندگی مشترک، به‌دنبال آرامش، پیش‌بینی‌پذیری، همکاری در تصمیم‌گیری‌ها و محیطی بدون درگیری هستند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ویژگی‌های مناسب برای همسر یک فرد SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. صبور و باثبات باشد</h3>
                    <p>
                        کسی که با تغییرات مداوم، هیجانات بالا یا نوسانات شدید خلقی زندگی نمی‌کند.
                    </p>
                    <p>
                        مثل: تیپ‌های High S  یا CS .
                    </p>
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. احترام‌گذار به قوانین، نظم و مرزهای فردی باشد</h3>
                    <p>
                        فرد  SCD مرزهای مشخصی دارد و بی‌نظمی‌های رفتاری یا عاطفی او را دل‌آزرده می‌کند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ویژگی‌های مناسب برای همسر یک فرد SCD">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. قابل اتکا و وفادار باشد</h3>
                    <p>
                        او نیاز دارد بداند شریک زندگی‌اش همیشه پشت اوست. حتی اگر ابراز هیجانی کم باشد، وفاداری در رفتار مهم‌تر است.
                    </p>
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. در مواجهه با احساسات، لطیف و آرام باشد</h3>
                    <p>
                        چون  SCDها اغلب در ابراز احساسات قوی نیستند، همسری که به آرامی بتواند فضا را برای بیان هیجانات ایجاد کند، مکمل عالی‌ای است.
                    </p>
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. ملاحظه‌کار، کم‌تنش و مشوق باشد</h3>
                    <p>
                        کسی که فضای عاطفی گرم، بدون فشار و همراه با انگیزه ایجاد کند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="مثال کاربردی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        تصور کنید همسر یک فرد  SCD، با تیپ High I  است. مدام برنامه‌های ناگهانی و پرهیجان طراحی می‌کند.
                    </p>
                    <p>
                        همسر  SCD با نگرانی، دچار استرس می‌شود. چون نه از تغییر ناگهانی خوشش می‌آید و نه اهل ریسک است.
                    </p>
                    <p>
                        اگر فرد High I  یاد بگیرد برنامه‌ها را با مشارکت طراحی کند، زمان بدهد و از هیجان‌زده کردن همسرش اجتناب کند، رابطه‌ای متعادل می‌سازند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="جمع‌بندی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        فرد  SCD در روابط خود:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>نیازمند احترام به نظم ذهنی‌اش است</li>
                        <li>از درگیری و رفتارهای تند فراری است</li>
                        <li>وقتی احساس امنیت کند، به‌شدت متعهد و حامی می‌شود</li>
                        <li>بهتر است با کسی باشد که "بلد است" آرام و منطقی باشد</li>
                    </ul>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که همسر فرد SCD باید بداند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        برای داشتن یک رابطه مؤثر، گرم و پایدار با همسر دارای تیپ رفتاری  SCD ، لازم است ویژگی‌های روانی او را بشناسیم و با رفتارهای مکمل، رابطه را رشد دهیم. در اینجا نکاتی کلیدی را برای همسر این تیپ ارائه می‌دهیم:
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که همسر فرد SCD باید بداند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۱. ناگهانی تصمیم نگیرید، اجازه دهید آماده شود</h3>
                    <p>
                        فرد  SCD نیاز به زمان برای پردازش تغییرات و تصمیم‌ها دارد. اگر ناگهان اعلام کنید که "آخر هفته می‌خواهیم برویم شمال!" احتمالاً نگران، مضطرب یا حتی کمی ناراحت می‌شود.
                    </p>
                    <p>
                        پیشنهاد: از قبل با او در میان بگذارید، مسیر، زمان، بودجه و جزئیات را روشن کنید.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که همسر فرد SCD باید بداند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۲. از رفتارهای پرتنش و صدای بلند اجتناب کنید</h3>
                    <p>
                        او از درگیری فراری است. بحث‌های تند، فریاد، یا قهر، او را بسته، سرد و خاموش می‌کند.
                    </p>
                    <p>
                        پیشنهاد: در زمان مناسب، با لحن ملایم و نگاه تحلیل‌گر گفت‌وگو کنید.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که همسر فرد SCD باید بداند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۳. به احساس نیاز او به ساختار و نظم احترام بگذارید</h3>
                    <p>
                        او در محیط‌های قابل‌پیش‌بینی، ساختارمند و آرام شکوفا می‌شود.
                    </p>
                    <p>
                        مثلاً اگر قرار است تغییری در برنامه خانواده یا فرزندان ایجاد شود، با مشارکت، نظر او را بپرسید.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که همسر فرد SCD باید بداند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۴. اگر ابراز احساساتش کم است، به معنی بی‌احساسی نیست</h3>
                    <p>
                        بسیاری از افراد  SCD درون‌گرا هستند و احساسات‌شان را به روش‌های غیرکلامی مثل توجه به جزئیات، انجام وظایف یا ثبات رفتاری نشان می‌دهند.
                    </p>
                    <p>
                        پیشنهاد: به‌جای توقع برای حرف‌های عاشقانه مکرر، زبان عشق او را بشناسید؛ مثلاً خدمات، حمایت یا وفاداری.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که همسر فرد SCD باید بداند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۵. او را بابت دقت، تعهد و آرامشش تحسین کنید</h3>
                    <p>
                        قدردانی از خصوصیات شخصیتی او به او انگیزه می‌دهد.
                    </p>
                    <p>
                        مثلاً بگویید: "همیشه وقتی تو هستی، احساس امنیت دارم" یا "خیالم از مدیریت خانواده کنار تو راحته."
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که همسر فرد SCD باید بداند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۶. در تصمیم‌گیری به او فضا بدهید، اما حمایت هم کنید</h3>
                    <p>
                        او تصمیم‌گیرنده محتاطی است؛ ممکن است بین انتخاب‌ها درگیر شود.
                    </p>
                    <p>
                        در مواقع نیاز، راه‌حل‌هایی آرام و تحلیل‌گر ارائه دهید، نه فشار برای انتخاب سریع.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="مثال از زندگی روزمره">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        فرض کنید همسر  SCD شما قرار است خانه را بازسازی کند.
                    </p>
                    <p>
                        اگر از او بخواهید "فردا بریم همه چیز رو یکجا بخریم"، به‌جای هیجان، دچار اضطراب می‌شود.
                    </p>
                    <p>
                        اما اگر مراحل را مشخص کنید اول کابینت، بعد رنگ، بعد وسایل، دقیق برنامه می‌ریزد و همراهی کامل می‌کند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که فرد SCD باید در زندگی زناشویی رعایت کند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        افراد با الگوی رفتاری  SCD معمولاً شریک زندگی‌ای وفادار، دقیق، حمایت‌گر و پایدار هستند. اما اگر برخی ویژگی‌های رفتاری خود را آگاهانه مدیریت نکنند، ممکن است در بلندمدت رابطه را به رکود، بی‌تفاوتی یا حتی رنجش عاطفی بکشانند. در ادامه، نکاتی برای رشد آگاهانه این تیپ در زندگی زناشویی آمده است:
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که فرد SCD باید در زندگی زناشویی رعایت کند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۱. هیجان و احساس را آگاهانه وارد رابطه کن</h3>
                    <p>
                        ممکن است شما خیلی محتاط و کنترل‌شده رفتار کنید و از بروز احساسات خودداری نمایید.
                    </p>
                    <p>
                        اما همسر شما برای حس عاطفه، نیازمند شنیدن، دیدن یا لمس محبت شماست. حتی یک پیام ساده مثل:
                    </p>
                    <p className="italic text-gray-700">
                        "فکر کردن بهت آرومم می‌کنه" می‌تونه معجزه کنه!
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که فرد SCD باید در زندگی زناشویی رعایت کند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۲. اجازه بده همیشه منطقی بودن، بین شما و عشق مانع نشه</h3>
                    <p>
                        در مواقع اختلاف، اگر فقط دنبال دلیل و تحلیل باشید و احساسات همسر را نادیده بگیرید، رابطه از تعادل خارج می‌شود.
                    </p>
                    <p>
                        گاهی بگذارید احساس، بر منطق مقدم باشد. همدلی کنید، نه فقط حل‌مسئله.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که فرد SCD باید در زندگی زناشویی رعایت کند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۳. از تصمیم‌گریزی یا تعویق زیاد پرهیز کن</h3>
                    <p>
                        در زندگی زناشویی، بعضی تصمیمات نیاز به قاطعیت دارند: مثلاً جابه‌جایی خانه، مدرسه فرزند، یا حتی رفتن به یک سفر.
                    </p>
                    <p>
                        شما می‌توانید در زمان کوتاه، اطلاعات کافی بگیرید و در کنار همسرتان تصمیم بگیرید. بلاتکلیفی فرساینده است.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که فرد SCD باید در زندگی زناشویی رعایت کند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۴. اجازه بده گاهی زندگی بی‌برنامه و پر از غافلگیری باشد</h3>
                    <p>
                        همسری که به تفریح، تغییر، تنوع و ماجراجویی علاقه‌مند است، ممکن است از ثبات بیش از حد شما دل‌زده شود.
                    </p>
                    <p>
                        سعی کن گاهی بدون برنامه، ریسک کوچک یا سفر یک‌روزه را امتحان کنی. شادی هم بخشی از پایداری رابطه است!
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که فرد SCD باید در زندگی زناشویی رعایت کند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۵. یاد بگیر از کمک خواستن نترسی</h3>
                    <p>
                        تو همیشه حامی و پشتیبان دیگران هستی، اما گاهی خودت نیاز به حمایت داری.
                    </p>
                    <p>
                        اگر خسته‌ای، بگو. اگر نگران هستی، درد دل کن. این قدرت است، نه ضعف.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکاتی که فرد SCD باید در زندگی زناشویی رعایت کند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۶. بلد باش نه بگویی، اما با مهربانی</h3>
                    <p>
                        زیاده‌روی در ملاحظه‌کاری ممکن است باعث شود خودت را فراموش کنی.
                    </p>
                    <p>
                        گاهی لازم است با احترام، مخالفتت را اعلام کنی تا همسرت بداند تو هم "نیاز و مرز" داری.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="تمرین پیشنهادی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        هفته‌ای یک بار، یک گفت‌وگوی بی‌دفاع با همسر ترتیب دهید.
                    </p>
                    <p>
                        بدون تحلیل، فقط درباره احساسات حرف بزنید. مثلاً بپرسید:
                    </p>
                    <p className="italic text-gray-700">
                        "این هفته چه چیزی از من باعث شد احساس امنیت یا نارضایتی کنی؟"
                    </p>
                    <p>
                        پیشنهاد تماشای مشترک:
                    </p>
                    <p>
                        فیلم A Beautiful Mind
                    </p>
                    <p>
                        شخصیتی با تیپ  SCD که با ذهن منطقی و ساختارمند خود، چالش‌های احساسی را تجربه می‌کند و می‌آموزد که عشق، فراتر از استدلال صرف است.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ارتباط مؤثر والدین SCD با فرزندان">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        والدین دارای الگوی رفتاری  SCD ترکیبی از ثبات، دقت و سطحی از تسلط معمولاً والدینی قابل‌اتکا، منظم، مراقب و مسئولیت‌پذیر هستند. اما برای داشتن رابطه‌ای سالم، گرم و رشددهنده با فرزندان، نکاتی هست که باید رعایت کنند:
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ارتباط مؤثر والدین SCD با فرزندان">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۱. به احساسات فرزندتان توجه کنید، نه فقط به عملکرد او</h3>
                    <p>
                        افراد  SCD ممکن است بیش‌ازحد روی "درست بودن، دقیق بودن و منظم بودن" تمرکز کنند، اما فرزندان گاهی فقط به آغوش، همدلی یا بازی نیاز دارند.
                    </p>
                    <p>
                        فرزندتان را فقط برای نمره خوب یا اتاق مرتب تشویق نکنید، بلکه برای احساسات و تلاشش هم ارزش قائل شوید.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ارتباط مؤثر والدین SCD با فرزندان">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۲. سخت‌گیری نکنید، ساختن رابطه مهم‌تر از نتیجه است</h3>
                    <p>
                        ممکن است در تلاش برای ساختن فرزند کامل، زیاد از باید و نبایدها استفاده کنید. این باعث فاصله عاطفی می‌شود.
                    </p>
                    <p>
                        گاهی با فرزندتان بنشینید، بخندید، اشتباهاتش را بپذیرید و بگویید "اشتباه کردن اشکال ندارد."
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="ارتباط مؤثر والدین SCD با فرزندان">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۳. اجازه دهید او تجربه کند، حتی اگر اشتباه کند</h3>
                    <p>
                        کنترل بیش‌ازحد برای محافظت، می‌تواند رشد او را محدود کند.
                    </p>
                    <p>
                        با نظارت ملایم، فضای آزمون و خطا فراهم کنید تا خودش مسیرها را کشف کند.
                    </p>
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>۴. برای تفریح و هیجان برنامه‌ریزی کنید</h3>
                    <p>
                        فرزند شما همیشه با انضباط و ساختار رشد نمی‌کند.
                    </p>
                    <p>
                        بازی، سفر، هیجان و حتی لحظاتی بدون برنامه، روحیه او را شادتر و رابطه‌تان را عمیق‌تر می‌کند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="مثال کاربردی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        فرض کنید فرزندتان مثلاً ۱۱ ساله ناگهان به شما می‌گوید "نمی‌خوام کلاس زبان برم دیگه!"
                    </p>
                    <p>
                        والد  SCD تمایل دارد فوراً بپرسد: "چرا؟ کلاس‌ خوبیه، نباید بی‌نظم باشی!"
                    </p>
                    <p>
                        اما راه مؤثرتر این است که بنشیند، بپرسد: "چی باعث شده علاقه‌ات کم بشه؟ دوست داری چی رو تغییر بدیم؟"
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="فیلم پیشنهادی">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        "Wonder"  ۲۰۱۷
                    </p>
                    <p>
                        روایتی از خانواده‌ای دقیق و حمایت‌گر پدر و مادر با الگوی  SCD که تلاش می‌کنند در کنار قوانین و نظم، احساس، همدلی و رشد فردی فرزندشان را فراموش نکنند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="فرزندان با والدین SCD چگونه ارتباط برقرار کنند">
                <div className="text-gray-800 leading-7 space-y-3">
                    <p>
                        برای فرزندان داشتن والدینی با تیپ شخصیتی  SCD، یعنی داشتن پدر یا مادری که همیشه مراقب، وظیفه‌شناس و پایدار هستند. اما برای ایجاد رابطه بهتر، فرزندان باید نکاتی را در نظر بگیرند:
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکات مهم برای فرزندان">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. با آن‌ها با احترام، آرامش و ادب صحبت کنید</h3>
                    <p>
                        والد  SCD از لحن تند یا بی‌نظمی در رفتار ناراحت می‌شود. اگر چیزی را نمی‌خواهید، با دلیل و لحن آرام مطرح کنید.
                    </p>
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. برنامه‌ها را به‌موقع اعلام کنید</h3>
                    <p>
                        ناگهانی نگویید "فردا اردو دارم باید پول بدی!" بلکه چند روز قبل بگویید تا برایش آماده شوند.
                    </p>
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. وقتی با شما صحبت می‌کنند، دقیق گوش دهید</h3>
                    <p>
                        آن‌ها اهل نصیحت‌اند، اما اگر ببینند شما شنونده‌اید، کوتاه‌تر و مؤثرتر حرف می‌زنند.
                    </p>
                </div>
            </Page>

            <Page testResult={testResult} title="نکات مهم برای فرزندان">
                <div className="text-gray-800 leading-7 space-y-3">
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. از تلاش آن‌ها برای حمایت قدردانی کنید</h3>
                    <p>
                        بگویید: "ممنونم که برام وقت گذاشتی" یا "می‌دونم چقدر زحمت می‌کشی."
                    </p>
                    <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. اگر ناراحت شدید، فرار نکنید یا پرخاش نکنید</h3>
                    <p>
                        بنشینید، حرفتان را بزنید. پدر یا مادر  SCD، اهل منطق‌اند و حرف منطقی را می‌پذیرند.
                    </p>
                </div>
            </Page>

        </>
    )
}

export default SCD;